import { render, staticRenderFns } from "./charge-details.vue?vue&type=template&id=3775112e&scoped=true&"
import script from "./charge-details.vue?vue&type=script&lang=ts&"
export * from "./charge-details.vue?vue&type=script&lang=ts&"
import style0 from "./charge-details.vue?vue&type=style&index=0&id=3775112e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3775112e",
  null
  
)

export default component.exports